/**
 * The schedule aside — `docs/new-request.md` §10.1, §16.1, Board 7.
 *
 * 560 px to the left of the form, inside the same sheet: One person's two
 * weeks, or up to three side by side. A pick here is live — it sets *Who
 * goes* and *When* on the form beside it at once, and the When box re-checks
 * as the block is dragged. **Esc** with focus in it closes it, before the
 * sheet's own Esc can (§19 B1).
 */
import { useRef } from 'react'
import { useRequestSheet } from '../sheet-context.js'
import { OnePane, SidePane, useEscapeCloses } from './panes.js'
import { useChoice } from './use-schedule.js'

export function ScheduleAside() {
  const api = useRequestSheet()
  const root = useRef<HTMLDivElement>(null)
  const choice = useChoice('live')
  useEscapeCloses(root, api.closeSchedule, Boolean(api.schedule))

  const schedule = api.schedule
  if (!schedule || schedule.people.length === 0) return null
  return (
    <div ref={root} className="flex min-h-0 flex-1 flex-col" data-schedule-aside={schedule.mode}>
      {schedule.mode === 'one'
        ? <OnePane variant="aside" choice={choice} />
        : <SidePane variant="aside" choice={choice} />}
    </div>
  )
}
